export default function ServerError() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-24">
      <h1 className="text-7xl font-extrabold text-primary-600 mb-4">500</h1>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Error interno del servidor</h2>
      <p className="text-gray-600 mb-6 text-center max-w-md">
        Algo salió mal en nuestro lado. Por favor, intenta de nuevo más tarde o contáctanos si el problema persiste.
      </p>
      <a href="#contact" className="rounded-full bg-primary-600 px-6 py-2 text-white font-semibold shadow hover:bg-primary-500 transition-colors">Contactar soporte</a>
    </div>
  )
} 